/* import __COLOCATED_TEMPLATE__ from './title.hbs'; */
/**

## Dialog Title

Contextual component used in the [Dialog Header](/components/glass/dialog-header.html) for [Modals](/components/glass/dialog-modal.html),
[Blades](/components/glass/dialog-blade.html), and [Sheets](/components/glass/dialog-sheet.html).


```example
@hbs
  {{dialog-header/title title="Dialog Title"}}
```

### Params
@param {String} title - Optional. Text for the title. If not passed, will use block content as the title.

*/

import Component from '@ember/component';
import { computed } from '@ember/object';
import { CONTEXT } from '../../utils/dialog-actions';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'h2',
  attributeBindings: ['data-test-dialog-title'],
  classNames: ['dialog__header__title'],
  classNameBindings: ['contextClass'],
  'data-test-dialog-title': true,
  contextClass: computed('context', function () {
    switch (this.get('context')) {
      case CONTEXT.BLADE:
        return 'dialog--blade__header__title';
      case CONTEXT.MODAL:
        return 'dialog--modal__header__title';
      case CONTEXT.SHEET:
        return 'dialog--sheet__header__title';
      default:
        return '';
    }
  })
});